import type { AxiosInstance } from 'axios';

/**
 * The axios instance every generated call runs through, registered by the app.
 *
 * This package deliberately owns no instance of its own. Everything that
 * differs between the two apps lives in interceptors on the instance they
 * create: web's bearer refresh and logout, its `paramsSerializer`, its ngrok
 * bypass and its analytics on failure; mobile's token store, its guest-token
 * header and its own refresh. Creating an instance here would mean choosing one
 * app's behaviour for both.
 *
 * It is an instance holder rather than a factory because both apps' tests stub
 * the network by mutating `defaults.adapter` on the instance they own, and that
 * only works if the client the package calls is the same object.
 */
let instance: AxiosInstance | undefined;

export class ApiClientNotConfiguredError extends Error {
  constructor() {
    super(
      'No axios instance has been registered. Call setApiClient(instance) ' +
        'once at startup, before any generated call runs.',
    );
    this.name = 'ApiClientNotConfiguredError';
  }
}

export function setApiClient(next: AxiosInstance): void {
  instance = next;
}

export function getApiClient(): AxiosInstance {
  if (!instance) {
    throw new ApiClientNotConfiguredError();
  }
  return instance;
}
